export const gtag = function() {
    // Can't use arrow func + destructuring as Google expects 
    // arguments objects in dataLayer (not an array of arguments).
    window.dataLayer.push(arguments); 
};

export default gtag;